module.exports = __webpack_public_path__ + "static/media/20.3222a4e2.jpg";